import { Component, OnInit, ViewChild } from '@angular/core';
import { Product } from '../../models/product.model';
import { wishlistService } from './../../services/wishlist.service';
import { CartService } from './../../services/cart.service';
import { ModalController, LoadingController, IonInfiniteScroll, ToastController } from '@ionic/angular';
import { ProductDetailsComponent } from '../product-details/product-details.component';
import { GlobalService } from '../../services/global.service';
import { cantidadesService } from "../../services/cantidades.service";
import { CartComponent } from '../cart/cart.component';
import { ApiService } from '../../api.service';
import { Storage } from '@ionic/storage';
import { PopoverController } from '@ionic/angular';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ShareComponent } from 'src/app/components/share/share.component';
import { Carro } from './../../models/carro.model';
import { FilterComponent } from '../filter/filter.component';

@Component({
    selector: 'app-wishlist',
    templateUrl: './wishlist.component.html',
    styleUrls: ['./wishlist.component.scss'],
})
export class WishlistComponent implements OnInit {
    @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;

    constructor(private cartService: CartService, private productsService: wishlistService, private route: ActivatedRoute,
        public ctdadService: cantidadesService,
        private router: Router, public popoverController: PopoverController, public storage: Storage,
        public modalController: ModalController, public global: GlobalService,
        public loadingController: LoadingController, public apiService: ApiService,
        public toastController: ToastController) { }

    products: Product[];
    searchTerm = '';
    resultado = '';
    nophoto = this.global.url + 'imagenes/NOFOTO.JPG';
    grid: Boolean = true;
    oneColumn: Boolean = false;
    list: Boolean = false;

    ionViewWillEnter() {
        console.log('Entra' + this.global.cambio);
        if (this.global.cambio === false) {
            this.products = this.global.whislist;
        } else {
            this.products = null;
        }
        

        if ((this.products === undefined) || (this.products == null)) {
            this.presentLoading();
            this.getProductList();
        }
    }
    ngOnInit() {
        
    }


    actualizaFavoritos()
    {
        console.log( "pillo evento");
        this.getProductList();
    }

    ionViewDidEnter() {

    }
 
    onError(item) {
        console.log(item.imagen);
        item.imagen = this.nophoto;
    }

    presentLoading() {
        this.loadingController.create({
            cssClass: 'my-custom-class',
            message: 'Cargando productos...'
        }).then((res) => {
            res.present();

            res.onDidDismiss().then((dis) => {
                console.log('Loading dismissed!', dis);
            });
        });

        setTimeout(() => {
            this.loadingController.dismiss().then((res) => {
                console.log('Loading dismissed!', res);
            }).catch((error) => {
                console.log('error', error);
            });
        }, 3000);
    }

    // Añadir a favoritos
    async FavAdd(articulo, e) {
        console.log(articulo);
        e.stopPropagation();


        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].codigo === articulo) {
                (this.products[i]);
                this.resultado = await this.apiService.FavAdd(this.products[i].codigo);
                (this.resultado);
                this.products[i].isWishlist = true;
                this.global.cambio = true;
            }
        }

    }

    // Get List of Products
    getProductList() {
        this.productsService.productList().then(products => {
            this.products = products;
            this.global.whislist = products;

            //recorremos el array del carro para poner cantidades
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < Object.keys(this.global.cartProducts.articulos).length; i++) {

                let found = this.products.find(x => x.codigo === this.global.cartProducts.articulos[i].codigo);
                if (found != null) {
                    found.cesta = true;
                    found.unid1 = this.global.cartProducts.articulos[i].unid1;
                    found.unid2 = this.global.cartProducts.articulos[i].unid2;
                }


                found = null;
            }
            (this.products);

            // quitamos la precarga
            this.loadingController.dismiss().then((res) => {
                console.log('Loading dismissed!', res);
            }).catch((error) => {
                console.log('error', error);
            });

        });
    }

    // Go to cart page function
    async gotoCartPage() {
        this.dismiss();
        const modal = await this.modalController.create({
            component: CartComponent
        });
        //ORIGINAL
        modal.onDidDismiss().then((data) => {
            ("recargo");
            //this.searchTerm = '';
            this.getProductList();
            (data);
        });
        return await modal.present();
    }

    // Back to previous page function
    dismiss() {
        this.modalController.dismiss({
            dismissed: true
        });
    }

    // A una columna
    showOneColumn() {
        this.oneColumn = true;
        this.grid = false;
        this.list = false;
    }

    // En Grid
    showGrid() {
        this.grid = true;
        this.oneColumn = false;
        this.list = false;
    }

    // En lista
    showList() {
        this.list = true;
        this.grid = false;
        this.oneColumn = false;
    }

}

